import React from 'react';

export default class Page9 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToInfluenceOthers');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>

                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">Further Information</span>
                                            </div>
                                            <div className="paraspace"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToMotivateOthers')}>How
                                                        to motivate others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToRaiseEnergyLevels')}>How
                                                        to raise energy levels</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBeAssertive')}>How
                                                        to be assertive</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToCommunicateEffectively')}>How
                                                        to communicate effectively</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToManageYourImpact')}>How
                                                        to manage your impact</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBuildAndMaintainTrust')}>How
                                                        to build and maintain trust</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToGainBuyInAndCommitment')}>How
                                                        to gain buy-in and commitment</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToEngageOthersToDeliver')}>How
                                                        to engage others to deliver.</div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES</div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Dambrun,
                                                    M., &amp; Vatiné, E. (2009). Reopening the study of extreme
                                                    social behaviors: Obedience to authority
                                                    within an immersive video environment. <span
                                                        className="subtiltereg">European Journal of Social Psychology,</span> 40(5),
                                                    760-773.</p></li>
                                                <li><p className="further_info_content"> Nicholson, I. (2011).
                                                    ‘Shocking’ Masculinity: Stanley Milgram, ‘Obedience to
                                                    Authority,’ and the ‘Crisis of
                                                    Manhood’ in Cold War America.<span
                                                        className="subtiltereg"> Isis,</span> 102(2), 238-268.
                                                </p></li>
                                                <li><p className="further_info_content">Milgram, S. (1963).
                                                    Behavioral study of obedience.<span className="subtiltereg">  Journal of Abnormal and Social Psychology,</span>
                                                    67, 371–378.</p></li>
                                                <li><p className="further_info_content">Manning, T. (2012). The
                                                    art of successful influence: matching influence strategies
                                                    and styles to the context.<span className="subtiltereg">
Industrial and Commercial Training,</span> 44(1), 26-34.</p></li>


                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page8')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }